import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { useUniquePrefix } from "../../../hooks/useUniquePrefix";
var BadConnection = function(param) {
    var width = param.width, height = param.height, title = param.title;
    var uniqueID = useUniquePrefix();
    return _jsxs("svg", {
        width: width,
        height: height,
        viewBox: "0 0 399 260",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            _jsx("title", {
                children: title
            }),
            _jsxs("defs", {
                children: [
                    _jsxs("linearGradient", {
                        x1: "13.3894231%",
                        y1: "40.1001785%",
                        x2: "100%",
                        y2: "59.8998215%",
                        id: "".concat(uniqueID, "BadConnection-linearGradient-1"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#EEC200"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#F27126"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "13.3894231%",
                        y1: "42.9521779%",
                        x2: "100%",
                        y2: "57.0478221%",
                        id: "".concat(uniqueID, "BadConnection-linearGradient-4"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#EEC200"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#F27126"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "13.3894231%",
                        y1: "47.6986703%",
                        x2: "100%",
                        y2: "52.3013297%",
                        id: "".concat(uniqueID, "BadConnection-linearGradient-9"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#EEC200"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#F27126"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "13.3894231%",
                        y1: "49.0465095%",
                        x2: "100%",
                        y2: "50.9534905%",
                        id: "".concat(uniqueID, "BadConnection-linearGradient-13"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#EEC200"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#F27126"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "0%",
                        y1: "38.6731154%",
                        x2: "73.3674654%",
                        y2: "54.8381311%",
                        id: "".concat(uniqueID, "BadConnection-linearGradient-17"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0"
                            }),
                            _jsx("stop", {
                                offset: "97.6810874%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0.4"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "3.0565022%",
                        y1: "3.81578571%",
                        x2: "3.0565022%",
                        y2: "100%",
                        id: "".concat(uniqueID, "BadConnection-linearGradient-18"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#E1E1E1"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FFFFFF"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "13.3894231%",
                        y1: "49.5858029%",
                        x2: "100%",
                        y2: "50.4141971%",
                        id: "".concat(uniqueID, "BadConnection-linearGradient-21"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#EEC200"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#F27126"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "13.3894231%",
                        y1: "48.9523922%",
                        x2: "100%",
                        y2: "51.0476078%",
                        id: "".concat(uniqueID, "BadConnection-linearGradient-24"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#EEC200"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#F27126"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "13.3894231%",
                        y1: "48.2918415%",
                        x2: "100%",
                        y2: "51.7081585%",
                        id: "".concat(uniqueID, "BadConnection-linearGradient-27"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#EEC200"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#F27126"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "13.3894231%",
                        y1: "48.7505246%",
                        x2: "100%",
                        y2: "51.2494754%",
                        id: "".concat(uniqueID, "BadConnection-linearGradient-30"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#EEC200"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#F27126"
                            })
                        ]
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "BadConnection-path-2"),
                        x: "19.3299011",
                        y: "117.60467",
                        width: "40.1467177",
                        height: "17.8640006"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "BadConnection-path-5"),
                        x: "251.288714",
                        y: "84.1096693",
                        width: "47.581295",
                        height: "17.8640006"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "BadConnection-path-7"),
                        x: "0",
                        y: "0",
                        width: "191.812096",
                        height: "132.491338",
                        rx: "4.65628099"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "BadConnection-path-10"),
                        x: "154.639209",
                        y: "52.103335",
                        width: "83.2672663",
                        height: "17.8640006"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "BadConnection-path-14"),
                        x: "-56.5027879",
                        y: "86.3426694",
                        width: "129.361646",
                        height: "17.8640006"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "BadConnection-path-19"),
                        x: "59.4766188",
                        y: "27.5403342",
                        width: "191.812096",
                        height: "132.491338",
                        rx: "4.65628099"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "BadConnection-path-22"),
                        x: "0",
                        y: "84.1096693",
                        width: "196.272842",
                        height: "17.8640006"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "BadConnection-path-25"),
                        x: "19.3299011",
                        y: "41.682668",
                        width: "123.413984",
                        height: "17.8640006"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "BadConnection-path-28"),
                        x: "182.890603",
                        y: "41.682668",
                        width: "96.6495055",
                        height: "17.8640006"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "BadConnection-path-31"),
                        x: "166.534533",
                        y: "117.60467",
                        width: "113.005576",
                        height: "17.8640006"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "BadConnection-path-33"),
                        x: "0",
                        y: "0",
                        width: "22.4821619",
                        height: "21.7940807"
                    }),
                    _jsxs("filter", {
                        x: "-229.2%",
                        y: "-352.7%",
                        width: "558.3%",
                        height: "1158.0%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "BadConnection-filter-3"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "34",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "6",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "25",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "13.5",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-193.4%",
                        y: "-352.7%",
                        width: "486.7%",
                        height: "1158.0%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "BadConnection-filter-6"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "34",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "6",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "25",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "13.5",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsx("filter", {
                        x: "-70.8%",
                        y: "-167.5%",
                        width: "241.5%",
                        height: "787.7%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "BadConnection-filter-11"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "2.97660009",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsxs("filter", {
                        x: "-121.2%",
                        y: "-402.7%",
                        width: "342.4%",
                        height: "1258.0%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "BadConnection-filter-12"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "34",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "6",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "25",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "13.5",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsx("filter", {
                        x: "-45.6%",
                        y: "-167.5%",
                        width: "191.1%",
                        height: "787.7%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "BadConnection-filter-15"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "2.97660009",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsxs("filter", {
                        x: "-78.0%",
                        y: "-402.7%",
                        width: "256.0%",
                        height: "1258.0%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "BadConnection-filter-16"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "34",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "6",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "25",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "13.5",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-30.2%",
                        y: "-37.6%",
                        width: "191.6%",
                        height: "248.5%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "BadConnection-filter-20"),
                        children: [
                            _jsx("feMorphology", {
                                radius: "1.34915004",
                                operator: "dilate",
                                in: "SourceAlpha",
                                result: "shadowSpreadOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "30",
                                dy: "59",
                                in: "shadowSpreadOuter1",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "19",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feComposite", {
                                in: "shadowBlurOuter1",
                                in2: "SourceAlpha",
                                operator: "out",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0",
                                type: "matrix",
                                in: "shadowBlurOuter1"
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-46.9%",
                        y: "-352.7%",
                        width: "193.7%",
                        height: "1158.0%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "BadConnection-filter-23"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "34",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "6",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "25",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "13.5",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-74.5%",
                        y: "-352.7%",
                        width: "249.1%",
                        height: "1158.0%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "BadConnection-filter-26"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "34",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "6",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "25",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "13.5",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-95.2%",
                        y: "-352.7%",
                        width: "290.4%",
                        height: "1158.0%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "BadConnection-filter-29"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "34",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "6",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "25",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "13.5",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-81.4%",
                        y: "-352.7%",
                        width: "262.8%",
                        height: "1158.0%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "BadConnection-filter-32"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "34",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "6",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "25",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "13.5",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.19 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0.949019608 0 0 0 0 0.443137255 0 0 0 0 0.149019608 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            _jsx("g", {
                stroke: "none",
                fill: "none",
                strokeWidth: "1",
                fillRule: "evenodd",
                children: _jsx("g", {
                    id: "".concat(uniqueID, "BadConnection-Hero/Error/Bad-Connection-(Unstable)"),
                    transform: "translate(12.000000, -64.000000)",
                    children: _jsxs("g", {
                        transform: "translate(38.000000, 65.000000)",
                        children: [
                            _jsx("rect", {
                                id: "".concat(uniqueID, "BadConnection-Rectangle-Copy-35"),
                                stroke: "#E1E1E1",
                                x: "60.2200765",
                                y: "0",
                                width: "191.812096",
                                height: "132.491338",
                                rx: "4.65628099",
                                strokeWidth: "0.800667747"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "BadConnection-Rectangle-Copy-39"),
                                stroke: "#E1E1E1",
                                x: "69.8850271",
                                y: "8.93200028",
                                width: "191.812096",
                                height: "132.491338",
                                rx: "4.65628099",
                                strokeWidth: "0.800667747"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "BadConnection-Rectangle-Copy-38"),
                                stroke: "#E1E1E1",
                                x: "49.8116682",
                                y: "17.8640006",
                                width: "191.812096",
                                height: "132.491338",
                                rx: "4.65628099",
                                strokeWidth: "0.800667747"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "BadConnection-Rectangle-Copy-33"),
                                fill: "#FFFFFF",
                                x: "59.4766188",
                                y: "28.2846676",
                                width: "191.812096",
                                height: "132.491338",
                                rx: "4.65628099"
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "BadConnection-filter-3)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "BadConnection-path-2")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "BadConnection-linearGradient-1)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "BadConnection-path-2")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "BadConnection-filter-6)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "BadConnection-path-5")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "BadConnection-linearGradient-4)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "BadConnection-path-5")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                id: "BadConnection-Rectangle-Copy-27-+-Rectangle-Copy-31-Mask",
                                transform: "translate(59.476619, 27.540334)",
                                children: [
                                    _jsx("mask", {
                                        id: "".concat(uniqueID, "BadConnection-mask-8"),
                                        fill: "white",
                                        children: _jsx("use", {
                                            xlinkHref: "#".concat(uniqueID, "BadConnection-path-7")
                                        })
                                    }),
                                    _jsx("use", {
                                        fill: "#ECECEC",
                                        fillOpacity: "0.7",
                                        xlinkHref: "#".concat(uniqueID, "BadConnection-path-7")
                                    }),
                                    _jsxs("g", {
                                        filter: "url(#".concat(uniqueID, "BadConnection-filter-11)"),
                                        mask: "url(#".concat(uniqueID, "BadConnection-mask-8)"),
                                        children: [
                                            _jsx("use", {
                                                fill: "black",
                                                filter: "url(#".concat(uniqueID, "BadConnection-filter-12)"),
                                                fillOpacity: "1",
                                                xlinkHref: "#".concat(uniqueID, "BadConnection-path-10")
                                            }),
                                            _jsx("use", {
                                                fill: "url(#".concat(uniqueID, "BadConnection-linearGradient-9)"),
                                                fillRule: "evenodd",
                                                xlinkHref: "#".concat(uniqueID, "BadConnection-path-10")
                                            })
                                        ]
                                    }),
                                    _jsxs("g", {
                                        filter: "url(#".concat(uniqueID, "BadConnection-filter-15)"),
                                        mask: "url(#".concat(uniqueID, "BadConnection-mask-8)"),
                                        children: [
                                            _jsx("use", {
                                                fill: "black",
                                                filter: "url(#".concat(uniqueID, "BadConnection-filter-16)"),
                                                fillOpacity: "1",
                                                xlinkHref: "#".concat(uniqueID, "BadConnection-path-14")
                                            }),
                                            _jsx("use", {
                                                fill: "url(#".concat(uniqueID, "BadConnection-linearGradient-13)"),
                                                fillRule: "evenodd",
                                                xlinkHref: "#".concat(uniqueID, "BadConnection-path-14")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "BadConnection-filter-20)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "BadConnection-path-19")
                                    }),
                                    _jsx("use", {
                                        stroke: "url(#".concat(uniqueID, "BadConnection-linearGradient-18)"),
                                        fill: "url(#".concat(uniqueID, "BadConnection-linearGradient-17)"),
                                        strokeWidth: "2.69830009",
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "BadConnection-path-19")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "BadConnection-filter-23)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "BadConnection-path-22")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "BadConnection-linearGradient-21)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "BadConnection-path-22")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "BadConnection-filter-26)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "BadConnection-path-25")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "BadConnection-linearGradient-24)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "BadConnection-path-25")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "BadConnection-filter-29)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "BadConnection-path-28")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "BadConnection-linearGradient-27)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "BadConnection-path-28")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "BadConnection-filter-32)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "BadConnection-path-31")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "BadConnection-linearGradient-30)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "BadConnection-path-31")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                id: "".concat(uniqueID, "BadConnection-People/Person-Copy-4"),
                                transform: "translate(99.780351, 93.786003)",
                                children: [
                                    _jsxs("g", {
                                        id: "".concat(uniqueID, "BadConnection-Bottom/Standing/2"),
                                        transform: "translate(4.303732, 66.990002)",
                                        children: [
                                            _jsx("path", {
                                                d: "M36.8923344,76.4090894 C42.1099807,75.493643 46.8332571,74.5802048 47.3499519,76.6755628 C47.7969559,78.4883027 46.5703242,79.2675362 45.1194077,79.998108 L44.7812591,80.1662859 C44.4972503,80.3064615 44.20907,80.4476391 43.927026,80.5968229 C42.6860324,81.2532319 40.1183955,82.1909495 36.2241151,83.4099757 C33.0732442,84.0976701 31.0079525,84.0976701 30.0282399,83.4099757 C29.3817482,82.3433288 29.3817482,80.8494542 30.0282399,78.9283518 C32.1586022,77.6643127 33.9315141,76.913383 35.3469755,76.6755628 C35.657499,76.6233899 35.9675713,76.5702039 36.2764367,76.5166169 Z M1.29376229,76.2037828 C3.45608599,74.9045766 5.26434764,74.3459505 6.71854722,74.5279047 C8.78218023,74.7861132 10.5271763,74.7727642 11.9779348,74.7691805 L12.4777894,74.7687793 C14.9163727,74.7733812 16.4475848,74.9114636 17.2055159,76.7290706 C17.7682846,78.0786553 16.8179034,78.5306684 15.30096,79.1092705 C13.8089709,79.6783544 10.9526662,80.4980946 6.73204599,81.5684909 C3.598563,81.8952066 1.60056247,81.6452103 0.738044394,80.8185019 C0.244879992,79.6419222 0.43011929,78.1036825 1.29376229,76.2037828 Z",
                                                fill: "#EEC200"
                                            }),
                                            _jsx("path", {
                                                d: "M30.896098,-4.26325641e-14 C35.5880102,14.7517567 39.6567326,31.9077661 39.6567326,39.7657497 L39.6567326,39.7657497 L39.6560319,42.1521196 C39.6462219,53.0953614 39.4990731,61.5734512 37.29184,77.6227133 C37.29184,78.557161 36.7238967,79.121985 35.5880102,79.3171854 C33.4776895,79.6798409 31.7640025,79.5822407 30.4469492,79.0243848 C27.703551,59.7627497 28.9035873,52.7814959 24.9521468,41.0430664 C24.6583647,40.1703366 24.352816,39.3282573 24.036416,38.5075971 C23.8290379,39.8852274 23.6098232,41.273538 23.3743112,42.6949613 C21.3747614,54.7631649 16.4165503,64.340408 8.38620325,75.4006735 C7.9426939,76.1577983 6.94723341,76.6271755 5.39982178,76.8088052 C3.52060879,77.0293805 2.0973281,76.84291 1.12997971,76.2493937 C7.59273059,58.0454412 8.97717541,54.1051221 8.97717541,39.7657497 C8.97717541,35.3205443 8.84413027,32.0791137 8.60974785,29.0188386 L8.56312663,28.4285147 C8.53121357,28.0361074 8.49764738,27.6456178 8.46249616,27.2548489 L8.40858908,26.6682116 C8.37186987,26.2766143 8.33359971,25.8836393 8.29384669,25.4870898 L8.23311356,24.8893099 C7.66635472,19.3800517 6.82568519,12.9873029 5.88818526,-4.26325641e-14 L5.88818526,-4.26325641e-14 Z",
                                                fill: "#5B5E65"
                                            }),
                                            _jsx("path", {
                                                d: "M8.93940646,-4.26325641e-14 C14.4758773,21.3928973 20.0971596,28.2901769 24.036416,38.5075971 C23.8290379,39.8852274 23.6098232,41.273538 23.3743112,42.6949613 C21.3747614,54.7631649 16.4165503,64.340408 8.38620325,75.4006735 C7.9426939,76.1577983 6.94723341,76.6271755 5.39982178,76.8088052 C3.52060879,77.0293805 2.0973281,76.84291 1.12997971,76.2493937 C7.59273059,58.0454412 8.97717541,54.1051221 8.97717541,39.7657497 C8.97717541,35.3205443 8.84413027,32.0791137 8.60974785,29.0188386 L8.56312663,28.4285147 C8.53121357,28.0361074 8.49764738,27.6456178 8.46249616,27.2548489 L8.40858908,26.6682116 C8.37186987,26.2766143 8.33359971,25.8836393 8.29384669,25.4870898 L8.23311356,24.8893099 C7.66635472,19.3800517 6.82568519,12.9873029 5.88818526,-4.26325641e-14 L5.88818526,-4.26325641e-14 L8.93940646,-4.26325641e-14 Z",
                                                fill: "#000000",
                                                fillOpacity: "0.15"
                                            })
                                        ]
                                    }),
                                    _jsxs("g", {
                                        id: "".concat(uniqueID, "BadConnection-Body/4"),
                                        transform: "translate(0.000000, 24.932000)",
                                        children: [
                                            _jsx("path", {
                                                d: "M24.3227255,0.786888168 C28.7412028,0.786888168 29.5884269,0.895917966 30.2414181,1.03297712 L30.4120519,1.0698565 C30.8863213,1.17380862 31.4166782,1.28905088 33.3456306,1.38338219 C33.7062614,1.40101807 34.0495132,1.44267001 34.3759568,1.50941164 L34.4274512,1.50144819 L34.4274512,1.50144819 C45.2517312,3.96702059 53.8770026,18.9823497 53.8770026,25.2853413 C53.8770026,31.5883329 47.2155898,41.0843615 43.2667837,42.2926413 C42.2010835,41.5552861 41.3764843,40.2935829 40.7929862,38.5075317 C44.027784,32.8594113 45.4523486,28.4520145 45.0666799,25.2853413 C44.788214,22.9988959 43.0515656,20.359329 39.8567347,17.3666408 L39.8551839,34.0695301 C39.8551839,46.1439292 43.542933,47.2813193 34.8870276,50.0641292 C26.2311222,52.8469391 7.04788239,56.1238557 8.72544692,46.4735572 C9.65130192,44.7188271 10.1542212,42.5034184 10.4022353,40.0304435 C5.45747269,35.9024375 0.160813819,29.6061819 0.160813819,25.6426213 C0.160813819,19.4311815 8.53733841,4.75866198 19.1401042,1.97404463 C20.7090482,1.21160329 22.4463533,0.786888168 24.3227255,0.786888168 Z M10.1363299,22.5025098 L10.0056755,22.7285845 C9.42739821,23.756459 9.08255188,24.7278046 8.97113647,25.6426213 C8.80571357,27.0008862 9.31215236,28.6280512 10.4904528,30.5241162 C10.3747423,27.8052311 10.2050567,25.0689707 10.1363299,22.5025098 Z",
                                                fill: "#FDF9E7"
                                            }),
                                            _jsx("path", {
                                                d: "M10.1922658,17.4426651 C10.0895716,19.0044681 10.0883864,20.7122173 10.1363323,22.5025992 C9.47902201,23.6142543 9.09069017,24.6609822 8.97113647,25.6426213 C8.8057379,27.0006864 9.3120034,28.6275725 10.4899329,30.5232796 C10.6324921,33.8289625 10.6951877,37.1093833 10.4022353,40.0304435 C5.45747269,35.9024375 0.160813819,29.6061819 0.160813819,25.6426213 C0.160813819,19.4317684 8.53575562,4.76143449 19.1370989,1.97483423 C13.9722302,4.49062795 10.6372977,10.6744952 10.1922658,17.4426651 Z",
                                                fill: "#000000",
                                                fillOpacity: "0.15"
                                            }),
                                            _jsx("path", {
                                                d: "M40.9989136,38.3065617 C38.1803131,39.7356818 36.7239491,40.6130468 36.7239491,42.1506767 C36.7239491,43.3558838 38.0271323,45.777517 40.133441,45.3666799 C42.2397497,44.9558428 42.7141822,43.6345554 43.542933,42.1506767 C42.6765724,39.8089521 42.1552227,39.0305422 40.9989136,38.3065617 Z",
                                                fill: "#DBB59D"
                                            })
                                        ]
                                    }),
                                    _jsxs("g", {
                                        id: "".concat(uniqueID, "BadConnection-Head/Back/1"),
                                        transform: "translate(17.685971, 0.000000)",
                                        children: [
                                            _jsxs("g", {
                                                transform: "translate(0.000000, 4.466000)",
                                                children: [
                                                    _jsx("mask", {
                                                        id: "".concat(uniqueID, "BadConnection-mask-34"),
                                                        fill: "white",
                                                        children: _jsx("use", {
                                                            xlinkHref: "#".concat(uniqueID, "BadConnection-path-33")
                                                        })
                                                    }),
                                                    _jsx("g", {}),
                                                    _jsx("path", {
                                                        d: "M13.3811937,2.38913562 C19.5687369,2.38913562 19.5981861,7.22877873 20.0263119,9.65800881 C20.5699654,12.7427545 19.5981861,17.5377732 17.9555498,18.5077326 C17.0882188,19.0198824 16.6109658,19.2517752 15.5131169,19.7447798 C14.0558522,20.399185 14.2930522,23.6241725 14.3179589,25.2891479 L14.6312482,27.5105609 L6.06661512,27.5105609 L7.30268945,21.7415262 C7.59537306,20.2074275 8.55699421,16.5849897 7.96225809,15.9471096 C6.21281276,14.070754 5.38513155,12.857067 5.38513155,10.7184003 C5.38513155,7.66878516 6.67996775,2.38913562 13.3811937,2.38913562 Z",
                                                        fill: "#DBB59D",
                                                        mask: "url(#".concat(uniqueID, "BadConnection-mask-34)")
                                                    })
                                                ]
                                            }),
                                            _jsx("path", {
                                                d: "M8.35794227,0.0595466685 C11.5614411,0.0595466685 14.1583899,2.65329653 14.1583899,5.85284913 L14.1580074,5.83256602 C16.9691063,6.06980051 19.0513597,7.98040524 19.3299011,9.86922925 C19.3299011,11.2551942 17.4938952,12.5904951 16.3066514,13.1060796 C16.3066514,12.293761 15.1201158,11.0986095 14.1290053,12.008233 C13.0704392,12.9797661 13.694609,14.1807214 14.6294285,14.5161064 C11.7488993,15.8579999 12.6996042,20.4457198 9.5294316,20.7582978 C6.35925896,21.0708759 5.23839609,18.20848 4.75478943,15.4695756 C4.54899854,14.3040797 4.51834953,12.4457786 5.14148239,10.674908 C3.58398831,9.63653909 2.55749461,7.86442166 2.55749461,5.85284913 C2.55749461,2.65329653 5.15444348,0.0595466685 8.35794227,0.0595466685 Z",
                                                fill: "#3C3226"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
BadConnection.defaultProps = {
    height: 400,
    width: 400
};
export default BadConnection;
